import { css } from "styled-components"

const families = {
  primary: `"Mulish", "Arial", "Helvetica Neue", "Helvetica", sans-serif`,
  secondary: `"Poppins", "Arial", "Helvetica Neue", "Helvetica", sans-serif`,
}

const weights = {
  primary: {
    normal: 400,
    bold: 700,
  },
  secondary: {
    semibold: 600,
    bold: 700,
  },
}

const set = (family, weight) => {
  try {
    return css`
      font-family: ${families[family]};
      font-weight: ${weights[family][weight]};
    `
  } catch (e) {
    // eslint-disable-next-line no-console
    return console.error(`Undefined font family/weight`, e.message, e.name)
  }
}

export default {
  set,
}
